import styled, { keyframes, css } from 'styled-components';
import { TextField } from '@material-ui/core';

const fadeIn = keyframes`
  from {
      opacity: 0;
      transform: translateY(-20px);
  }
  to {
      opacity: 1;
      transform: translateY(0);
  }
`;

const detectBrowser = () => {
  const userAgent = navigator.userAgent;

  if (userAgent.includes('Chrome')) {
    return 'chrome';
  } else if (userAgent.includes('Firefox')) {
    return 'firefox';
  } else if (userAgent.includes('Safari')) {
    return 'safari';
  } else {
    return 'other'; // Para outros navegadores
  }
};

const getScrollbarStyles = (browser: string) => {
  if (browser !== 'firefox') {
    return css`
      /* Estilizando o Scrollbar para Chrome/Safari */
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px; /* Para barras de rolagem horizontais */
      }

      &::-webkit-scrollbar-thumb {
        cursor: pointer;
        background-color: ${props =>
          props.theme.secundaria}; /* Cor do "thumb" */
        border-radius: 10px;
        border: 3px solid transparent;
      }

      &::-webkit-scrollbar-track {
        background-color: #f0f0f0; /* Cor do "track" */
      }

      /* Remove as setas do scrollbar em WebKit */
      &::-webkit-scrollbar-button {
        display: none; /* Remove as setas do scrollbar */
      }
    `;
  } else {
    return css`
      /* Estilizando o Scrollbar para Firefox */
      scrollbar-width: thin; /* Largura do scrollbar: "auto" ou "thin" */
      scrollbar-color: ${props => props.theme.secundaria} #f0f0f0; /* Cor do thumb e do track */
    `;
  }
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  animation: ${fadeIn} 2s;
  overflow: hidden;

  h3 {
    color: ${props => props.theme.secundaria};
    margin-top: 10px;
  }

  h2 {
    color: ${props => props.theme.secundaria};
  }

  .MuiTextField-root {
    /* contorno do input */
    & .MuiOutlinedInput-root {
      fieldset {
        &.MuiOutlinedInput-notchedOutline {
          border-color: ${props => props.theme.secundaria} !important;
        }
      }
    }
    /* Contorno do input no hover */
    &:hover {
      & .MuiOutlinedInput-root {
        fieldset {
          &.MuiOutlinedInput-notchedOutline {
            border-color: ${props => props.theme.secundariaShade} !important;
          }
        }
      }
    }
    /* contorno quando foca no input */
    & .MuiOutlinedInput-root {
      &.Mui-focused fieldset {
        border-color: ${props => props.theme.secundariaShade} !important;
      }
    }
    /* cor da fonte do input */
    & .MuiOutlinedInput-input {
      color: ${props => props.theme.texto} !important;
      /* letra maiúscula no input */
      text-transform: uppercase;
    }
    /* label quando preenchido */
    & label.MuiFormLabel-filled {
      color: ${props => props.theme.secundaria} !important;
    }
    /* label em cima do input */
    & label.Mui-focused {
      color: ${props => props.theme.secundariaShade} !important;
    }
    /* seria o placeholder */
    > label {
      color: ${props => props.theme.textoClaro};
    }
  }
`;

export const ContainerFields = styled.span`
  animation: ${fadeIn} 1s;

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;

  gap: 8px;

  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ContainerMonetizacoes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  height: 300px;
  overflow-y: auto;
  ${getScrollbarStyles(detectBrowser())};
`;

export const CardMonetizacao = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-right: 5px;

  border: 1px solid ${props => props.theme.secundaria};
  border-left: 5px solid ${props => props.theme.secundaria};
  padding: 10px;

  img {
    display: flex;

    height: 40px;
    width: 60px;

    object-fit: contain;
  }

  p {
    color: ${props => props.theme.secundaria};
  }

  h4 {
    color: ${props => props.theme.secundaria};
  }

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;

    span {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  svg {
    cursor: pointer;
    margin-left: 10px;
    color: ${props => props.theme.secundaria};
    &:hover {
      color: ${props => props.theme.secundariaShade};
    }

    height: 18px;
    width: 18px;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  flex: 1;
  width: 100%;
  margin-right: 8px;

  gap: 8px;
  @media (max-width: 768px) {
    gap: 0;
  }
`;

export const ConfirmButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  align-self: flex-start;
  height: 56px;
  width: 56px;

  margin-top: 15px;

  border: none;
  border-radius: 8px;
  background-color: ${props => props.theme.secundaria};

  svg {
    height: 30px;
    width: 30px;
    color: #ffffff;
  }

  &:hover {
    background-color: ${props => props.theme.secundariaShade};
  }

  @media (max-width: 768px) {
    margin: 15px 0px 0px 8px;

    svg {
      height: 20px;
      width: 20px;
    }
  }
`;

export const InputCategoria = styled(TextField)`
  align-self: flex-start;
  flex: 3;
  width: 100%;
`;

export const InputPreco = styled(TextField)`
  align-self: flex-start;
  flex: 1;
  width: 100%;
`;

export const InputCusto = styled(TextField)`
  align-self: flex-start;
  flex: 1;
  width: 100%;
`;
